export const integrationsGetWhatsAppData = "/engagement/whatsapp/account_data";
